import type {
  MediaFiles,
  MediaState,
} from "@/features/media/types/media.types";
import { createSlice, type PayloadAction } from "@reduxjs/toolkit";
import { PortFeature } from "../survey/types";

const initialState: MediaState = {
  mediaFiles: {},
  marinePorts: [],
};

export const mediaSlice = createSlice({
  name: "media",
  initialState,
  reducers: {
    setPropertyMedia: (state, action: PayloadAction<MediaFiles>) => {
      if (!state.mediaFiles) {
        state.mediaFiles = {};
      }
      // Merge the propertyMedia with existing mediaFiles without overwriting
      Object.entries(action.payload).forEach(([propertyId, mediaData]) => {
        if (!state.mediaFiles![propertyId]) {
          state.mediaFiles![propertyId] = {
            images: [],
            floorPlans: [],
            fliers: [],
          };
        }
        // Update each media type for this property
        if (mediaData.images?.length) {
          state.mediaFiles![propertyId].images = mediaData.images;
        }
        if (mediaData.floorPlans?.length) {
          state.mediaFiles![propertyId].floorPlans = mediaData.floorPlans;
        }
        if (mediaData.fliers?.length) {
          state.mediaFiles![propertyId].fliers = mediaData.fliers;
        }
      });
    },
    setMarinePorts: (state, action: PayloadAction<PortFeature[]>) => {
      state.marinePorts = action.payload;
    },
  },
});

export const { setPropertyMedia, setMarinePorts } = mediaSlice.actions;

export default mediaSlice.reducer;
